import update from 'immutability-helper';
import {
  API_TREASURE_REDEEM_SUCCESS,
  USER_PROFILE_FETCH_REQUEST,
  USER_PROFILE_FETCH_SUCCESS,
  USER_PROFILE_SAVE_SUCCESS,
  PLAYER_CONFIRM_MEDIA,
  PLAYER_COINS_CHANGED,
  USER_DEFINITIONS_FETCH_REQUEST,
  USER_DEFINITIONS_FETCH_SUCCESS,
  USER_DEFINITIONS_SAVE_REQUEST,
  USER_DEFINITIONS_SAVE_SUCESS,
  USER_UPDATE_PASSWORD_SUCCESS,
  USER_TREASURES_FETCH_SUCCESS,
  USER_UPDATE_COINS,
  AUTH_LOGOUT,
  SIDEBAR_STATUS,
  SET_MEDIA_SETTINGS,
  HELP_STATUS,
} from '../actions/types';
import {createReducer} from '../utils';

const initialState = {
  isFetchingUser: false,
  isFetchingDefinitions: false,
  isSavingDefinitions: false,
  updateProfileSuccess: false,
  updatePasswordSuccess: false,
  profile: {},
  coins: {gold: 0, silver: 0},
  audioSource: null,
  videoSource: null,
  availablePoints: 0,
  definitions: [],
  treasures: [],
  sidebar: false,
  help: false,
  mediaSettings: false,
};

const userReducer = createReducer(initialState, {
  [SIDEBAR_STATUS]: (state, {status}) => (
    update(state, {
      sidebar: {$set: status},
    })
  ),
  [SET_MEDIA_SETTINGS]: (state, {visible}) => (
    update(state, {
      mediaSettings: {$set: visible},
    })
  ),
  [HELP_STATUS]: (state, {status}) => (
    update(state, {
      help: {$set: status},
    })
  ),
  [USER_PROFILE_FETCH_REQUEST]: state => (
    update(state, {isFetchingUser: {$set: true}})
  ),
  [USER_PROFILE_FETCH_SUCCESS]: (state, payload) => {
    const {user, coins} = payload;

    user.fullName = `${user.firstName} ${user.lastName}`;

    return update(state, {
      isFetchingUser: {$set: false},
      profile: {$set: user},
      coins: {$set: coins},
    });
  },
  [API_TREASURE_REDEEM_SUCCESS]: (state, {response: {goldCoins}}) => update(state, {
    coins: {gold: {$set: goldCoins}},
  }),
  [USER_UPDATE_COINS]: (state, {coins}) => update(state, {
    coins: {silver: {$set: coins}},
  }),
  [USER_DEFINITIONS_FETCH_REQUEST]: state => (
    update(state, {isFetchingDefinitions: {$set: true}})
  ),
  [USER_DEFINITIONS_FETCH_SUCCESS]: (state, payload) => {
    const {response} = payload;
    return update(state, {
      isFetchingDefinitions: {$set: false},
      definitions: {$set: response},
    });
  },
  [USER_DEFINITIONS_SAVE_REQUEST]: state => (
    update(state, {isSavingDefinitions: {$set: true}})
  ),
  [USER_DEFINITIONS_SAVE_SUCESS]: (state, payload) => {
    const {response} = payload;
    return update(state, {
      isSavingDefinitions: {$set: false},
      definitions: {$merge: response},
    });
  },

  [USER_TREASURES_FETCH_SUCCESS]: (state, payload) => {
    const {response: {availablePoints, treasures}} = payload;
    return update(state, {
      availablePoints: {$set: availablePoints},
      treasures: {$set: treasures},
    });
  },
  [USER_PROFILE_SAVE_SUCCESS]: (state, payload) => {
    const {user} = payload;
    user.fullName = `${user.firstName} ${user.lastName}`;
    return update(state, {
      updateProfileSuccess: {$set: true},
      profile: {$merge: user},
    });
  },
  [USER_UPDATE_PASSWORD_SUCCESS]: state => update(state, {updatePasswordSuccess: {$set: true}}),
  [PLAYER_CONFIRM_MEDIA]: (state, payload) => {
    const {audioSource, videoSource} = payload;

    return update(state, {
      audioSource: {$set: audioSource},
      videoSource: {$set: videoSource},
    });
  },
  [AUTH_LOGOUT]: () => initialState,
  '@@router/LOCATION_CHANGE': (state, action) => {
    const {payload: {pathname}} = action;
    if (pathname !== '/profile/password' && pathname !== '/profile/edit') {
      return update(state, {updateProfileSuccess: {$set: false},
        updatePasswordSuccess: {$set: false}});
    }
    if (pathname !== '/profile/password') {
      return update(state, {updatePasswordSuccess: {$set: false}});
    }
    if (pathname !== '/profile') {
      return update(state, {updateProfileSuccess: {$set: false}});
    }
    return {...state};
  },
  [PLAYER_COINS_CHANGED]: (state, {coins}) => update(state, {
    coins: {$set: coins},
  }),
});

export default userReducer;
